"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Conversation = _interopRequireDefault(require("./Conversation"));

var _conversationsHelpers = require("composer-lib/lib/helpers/conversationsHelpers");

var _reactKeybindings = require("react-keybindings");

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var Conversations = (0, _createReactClass.default)({
  displayName: "Conversations",
  propTypes: {
    closeConversations: _propTypes.default.func,
    conversations: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    currentUserId: _propTypes.default.number.isRequired,
    deleteComment: _propTypes.default.func,
    deleteCommentId: _propTypes.default.number,
    deleteCommentStatus: _propTypes.default.string,
    deleteConversation: _propTypes.default.func,
    deleteConversationDone: _propTypes.default.func,
    deleteConversationId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    deleteConversationStatus: _propTypes.default.string,
    highlightBodyText: _propTypes.default.func,
    highlightSummaryText: _propTypes.default.func,
    highlightTitleText: _propTypes.default.func,
    index: _propTypes.default.string.isRequired,
    openConversation: _propTypes.default.func,
    openConversations: _propTypes.default.instanceOf(_immutable.Set),
    refetchUsers: _propTypes.default.func,
    registerListener: _propTypes.default.func,
    removeHighlightedBodyText: _propTypes.default.func,
    removeHighlightedSummaryText: _propTypes.default.func,
    removeHighlightedTitleText: _propTypes.default.func,
    saveComment: _propTypes.default.func,
    selectConversationBlock: _propTypes.default.func.isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired,
    userIsAdmin: _propTypes.default.bool
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var lastConversationInBlock = this.props.conversations.last(); // Only auto-open the last conversation in block if it is a new one (no comments)
    // or if there is only one conversation belonging to the block

    if (this.props.conversations.size === 1 || lastConversationInBlock.comments.size === 0) {
      this.props.openConversation(lastConversationInBlock.id);
    }

    this.setClickToHideConversationsListener(true);
  },
  componentDidMount: function componentDidMount() {
    this.props.registerListener('escape', this.handleEscape);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props.closeConversations(this.getAllConversationIdsInBlock());
    this.setClickToHideConversationsListener(false);
  },
  handleBodyClick: function handleBodyClick(e) {
    if ((0, _conversationsHelpers.elIsOrContainedByConversations)(e.target)) {
      return;
    }

    this.selectClear();
  },
  handleEscape: function handleEscape(e) {
    e.preventDefault();
    this.selectClear();
  },
  setClickToHideConversationsListener: function setClickToHideConversationsListener(shouldBeOn) {
    if (shouldBeOn) {
      document.body.addEventListener('click', this.handleBodyClick);
    } else {
      document.body.removeEventListener('click', this.handleBodyClick);
    }
  },
  selectClear: function selectClear() {
    this.props.removeHighlightedBodyText();
    this.props.selectConversationBlock(null);
  },
  getAllConversationIdsInBlock: function getAllConversationIdsInBlock() {
    return this.props.conversations.keySeq().toList();
  },
  closeConversationsInBlock: function closeConversationsInBlock() {
    var conversationIdsToDelete = this.getAllConversationIdsInBlock();
    this.props.closeConversations(conversationIdsToDelete);
  },
  setConversationOpen: function setConversationOpen(open, id) {
    if (open) {
      this.props.openConversation(id);
    } else {
      this.props.closeConversations(new _immutable.List([id]));
    }
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        conversations = _this$props.conversations,
        index = _this$props.index;
    return _react.default.createElement("div", {
      className: "conversations-block"
    }, conversations.valueSeq().filter(function (c) {
      return !!c && c.comments && (c.comments.size > 0 || c.isEmptyDummy);
    }).map(function (conversation) {
      return _react.default.createElement(_Conversation.default, {
        conversation: conversation,
        currentUserId: _this.props.currentUserId,
        deleteComment: _this.props.deleteComment,
        deleteCommentId: _this.props.deleteCommentId,
        deleteCommentStatus: _this.props.deleteCommentStatus,
        deleteConversation: _this.props.deleteConversation,
        deleteConversationDone: _this.props.deleteConversationDone,
        deleteConversationId: _this.props.deleteConversationId,
        deleteConversationStatus: _this.props.deleteConversationStatus,
        refetchUsers: _this.props.refetchUsers,
        highlightBodyText: _this.props.highlightBodyText,
        highlightSummaryText: _this.props.highlightSummaryText,
        highlightTitleText: _this.props.highlightTitleText,
        index: index,
        key: conversation.id,
        selectConversationBlock: _this.props.selectConversationBlock,
        open: _this.props.openConversations.has(conversation.id),
        removeHighlightedBodyText: _this.props.removeHighlightedBodyText,
        removeHighlightedSummaryText: _this.props.removeHighlightedSummaryText,
        removeHighlightedTitleText: _this.props.removeHighlightedTitleText,
        saveComment: _this.props.saveComment,
        setConversationOpen: _this.setConversationOpen,
        setClickToHideConversationsListener: _this.setClickToHideConversationsListener,
        users: _this.props.users,
        userIsAdmin: _this.props.userIsAdmin
      });
    }));
  }
});

var _default = (0, _reactKeybindings.KeyboundComponent)(Conversations);

exports.default = _default;
module.exports = exports.default;